import { memo } from 'react'

interface ExternalLinkIconProps {
  size?: number
  className?: string
}

const ExternalLinkIcon: React.FC<ExternalLinkIconProps> = memo(
  ({ size = 12, className = '' }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        className={className}
      >
        <path
          d="M1.27606 12C0.919471 12 0.617647 11.8765 0.370588 11.6294C0.123529 11.3824 0 11.0805 0 10.7239V1.27606C0 0.919471 0.123529 0.617647 0.370588 0.370588C0.617647 0.123529 0.919471 0 1.27606 0H5.199C5.34924 0 5.47506 0.0507058 5.57647 0.152118C5.67776 0.253412 5.72841 0.379176 5.72841 0.529412C5.72841 0.679647 5.67776 0.805412 5.57647 0.906706C5.47506 1.00812 5.34924 1.05882 5.199 1.05882H1.27606C1.22171 1.05882 1.17194 1.08147 1.12676 1.12676C1.08147 1.17194 1.05882 1.22171 1.05882 1.27606V10.7239C1.05882 10.7783 1.08147 10.8281 1.12676 10.8732C1.17194 10.9185 1.22171 10.9412 1.27606 10.9412H10.7239C10.7783 10.9412 10.8281 10.9185 10.8732 10.8732C10.9185 10.8281 10.9412 10.7783 10.9412 10.7239V6.801C10.9412 6.65077 10.9919 6.52494 11.0933 6.42353C11.1946 6.32224 11.3204 6.27159 11.4706 6.27159C11.6208 6.27159 11.7466 6.32224 11.8479 6.42353C11.9493 6.52494 12 6.65077 12 6.801V10.7239C12 11.0805 11.8765 11.3824 11.6294 11.6294C11.3824 11.8765 11.0805 12 10.7239 12H1.27606ZM10.9412 1.80265L4.76206 7.98194C4.66429 8.07959 4.54141 8.12959 4.39341 8.13194C4.24553 8.13418 4.12041 8.08418 4.01806 7.98194C3.91582 7.87959 3.86471 7.75559 3.86471 7.60994C3.86471 7.46429 3.91582 7.34029 4.01806 7.23794L10.1974 1.05882H7.94118C7.79094 1.05882 7.66518 1.00812 7.56388 0.906706C7.46247 0.805412 7.41176 0.679647 7.41176 0.529412C7.41176 0.379176 7.46247 0.253412 7.56388 0.152118C7.66518 0.0507058 7.79094 0 7.94118 0H11.3619C11.5439 0 11.6957 0.0608819 11.8174 0.182647C11.9391 0.304294 12 0.456117 12 0.638117V4.05882C12 4.20906 11.9493 4.33482 11.8479 4.43612C11.7466 4.53753 11.6208 4.58824 11.4706 4.58824C11.3204 4.58824 11.1946 4.53753 11.0933 4.43612C10.9919 4.33482 10.9412 4.20906 10.9412 4.05882V1.80265Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)

ExternalLinkIcon.displayName = 'ExternalLinkIcon'

export { ExternalLinkIcon }
